import { connect } from 'react-redux'
import { BabylistStoreIcon } from 'components/icons'
import { getRegItemsBabylistCount } from 'registry/reducers'

import SetupGoal from './setup-goal'

function getText(state) {
  return <>Complete 40% of your registry checklist.</>
}

function mapStateToProps(state, ownProps) {
  return {
    ...ownProps,
    icon: <BabylistStoreIcon alternate={ownProps.alternateIcon} />,
    text: getText(state),
  }
}

export default connect(mapStateToProps)(SetupGoal)
